<template>
	<div class="add-user-machine-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="
				userGroupTransfer.id
					? $t('addUserMachineGroup.edit')
					: $t('addUserMachineGroup.add')
			"
			:visible.sync="dialogUserGroupTransfer"
			width="60%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					ref="userGroupTransfer"
					label-width="80px"
					:model="userGroupTransfer">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('addUserMachineGroup.name')" prop="name">
								<el-input
									v-model="userGroupTransfer.name"
									:placeholder="$t('addUserMachineGroup.pName')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="!userGroupTransfer.id">
						<el-col :span="24">
							<h4 style="margin-top: 10px; color: red; font-weight: normal">
								{{ $t("addUserMachineGroup.noList") }}
							</h4>
							<el-table
								v-el-table-infinite-scroll="loadAddUnSelect"
								v-loading="loading"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								height="350px"
								:data="unselectList"
								style="width: 100%; margin-top: 10px"
								@selection-change="handleUnselect">
								<el-table-column type="selection" width="30"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="equipmentName"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-else>
						<el-col :span="12">
							<h4 style="margin-top: 10px; color: red; font-weight: normal">
								{{ $t("addUserMachineGroup.noList") }}
							</h4>
							<el-button
								style="margin-bottom: 10px"
								type="primary"
								class="right"
								v-if="userGroupTransfer.id"
								size="small"
								icon="el-icon-plus"
								:disabled="unselectChangeList.length <= 0"
								@click="addMachine(0)"
								>{{ $t("addUserMachineGroup.addM") }}</el-button
							>
							<el-table
								v-loading="loading"
								v-el-table-infinite-scroll="loadEditUnSelect"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="unselectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="handleUnselect">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="name"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
						<el-col :span="12">
							<h4 style="margin-top: 10px; color: green; font-weight: normal">
								{{ $t("addUserMachineGroup.yesList") }}
							</h4>
							<el-button
								style="margin-bottom: 10px"
								type="danger"
								class="right"
								size="small"
								v-if="userGroupTransfer.id"
								icon="el-icon-delete"
								:disabled="selectChangeList.length <= 0"
								@click="addMachine(1)"
								>{{ $t("addUserMachineGroup.remM") }}</el-button
							>
							<el-table
								v-loading="loadingSelect"
								v-el-table-infinite-scroll="loadEditSelect"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="selectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="select">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									prop="equipmentNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.equipmentNo')
									"></el-table-column>
								<el-table-column
									prop="name"
									:label="$t('addUserMachineGroup.equipmentName')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="handleSubmitForm('userGroupTransfer')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import elTableInfiniteScroll from "el-table-infinite-scroll";
export default {
	directives: {
		"el-table-infinite-scroll": elTableInfiniteScroll,
	},
	name: "AddUserMachineGroup",
	props: {
		dialogUserGroupTransfer: Boolean,
		userGroupTransfer: Object,
	},
	data() {
		return {
			labelPosition: "top",
			clear: false,
			loading: false,
			userMachineList: [],
			unselectList: [],
			selectList: [],
			unselectChangeList: [],
			selectChangeList: [],
			addUnSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			editUnSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			editSelect: {
				loading: false,
				page: {
					pageSize: 10,
					pageIndex: 1,
					pages: 1,
				},
			},
			search: {
				searchType: "1",
			},
			yxsearch: {
				searchType: "0",
			},
			loadingSelect: false,
			loadingForm: false,
		};
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		// 弹窗关闭事件
		closeDialog() {
			this.clearValidate("userGroupTransfer");
			if (this.userGroupTransfer.id) {
				this.$toolUtil.clearForm(this.userGroupTransfer);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.userGroupTransfer);
				}
			}
			this.cancel("");
		},
		// 关闭弹窗
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		// 弹窗打开事件
		openDialog() {
			this.addUnSelect.page.pageIndex = 1;
			this.editSelect.page.pageIndex = 1;
			this.editUnSelect.page.pageIndex = 1;
			this.unselectList = [];
			this.selectList = [];
			if (this.userGroupTransfer.id) {
				this.loadEditUnSelect();
				this.loadEditSelect();
			} else {
				this.loadAddUnSelect();
			}
		},
		// 滚动加载未添加分组设备
		loadAddUnSelect() {
			if (
				!this.addUnSelect.loading &&
				this.addUnSelect.page.pages >= this.addUnSelect.page.pageIndex
			) {
				this.addUnSelect.loading = true;
				this.loading = true;
				let obj = this.$cloud.objMerge(this.search, this.addUnSelect.page);
				this.$api
					.request(this.$url.UserMachine.userEquipment, this.$method.get, obj)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.unselectList = this.unselectList.concat(res.data.records);
							this.addUnSelect.page.pages = parseInt(res.data.pages);
							this.addUnSelect.page.pageIndex =
								this.addUnSelect.page.pageIndex + 1;
						}
						this.addUnSelect.loading = false;
						this.loading = false;
					})
					.catch(() => {
						this.addUnSelect.loading = false;
						this.loading = false;
					});
			}
		},
		// 提交创建分组表单
		handleSubmitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (!this.userGroupTransfer.name) {
						this.$notify({
							title: this.$t("common.tip"),
							message: this.$t("addUserMachineGroup.pName"),
							type: "warning",
						});
						return false;
					}
					let url = this.$url.UserMachineGroup.userMoveGroupInsert;
					let method = this.$method.post;
					let localSelectChangeList = [];
					if (this.userGroupTransfer.id) {
						localSelectChangeList = this.selectChangeList;
						url = this.$url.UserMachineGroup.userMoveGroupUpdate;
						method = this.$method.put;
					} else {
						delete this.userGroupTransfer.id;
						localSelectChangeList = this.unselectChangeList;
					}
					if (!this.userGroupTransfer.id) {
						if (localSelectChangeList.length > 0) {
							this.userGroupTransfer.userMachineId = this.$cloud.getIds(
								localSelectChangeList
							);
						} else {
							this.userGroupTransfer.userMachineId = [];
						}
						if (this.userGroupTransfer.userMachineId.length < 1) {
							this.$notify({
								title: this.$t("common.tip"),
								message: this.$t("addUserMachineGroup.qxzytjsb"),
								type: "warning",
							});
							return false;
						}
					}
					this.loadingForm = true;
					this.$api
						.request(url, method, this.userGroupTransfer)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.cancel(this.userGroupTransfer.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		// 已添加设备分组全选触发事件
		select(val) {
			this.selectChangeList = val;
		},
		// 未添加分组设备全选触发事件
		handleUnselect(val) {
			this.unselectChangeList = val;
		},
		// 滚动加载未添加分组设备
		loadEditUnSelect() {
			if (
				!this.editUnSelect.loading &&
				this.editUnSelect.page.pages >= this.editUnSelect.page.pageIndex
			) {
				this.editUnSelect.loading = true;
				this.loading = true;
				let obj = this.$cloud.objMerge(this.search, this.editUnSelect.page);
				this.$api
					.request(this.$url.UserMachine.userEquipment, this.$method.get, obj)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.unselectList = this.unselectList.concat(res.data.records);
							this.editUnSelect.page.pages = parseInt(res.data.pages);
							this.editUnSelect.page.pageIndex =
								this.editUnSelect.page.pageIndex + 1;
						}
						this.editUnSelect.loading = false;
						this.loading = false;
					})
					.catch(() => {
						this.editUnSelect.loading = false;
						this.loading = false;
					});
			}
		},
		// 滚动加载已添加分组设备
		loadEditSelect() {
			if (
				!this.editSelect.loadingSelect &&
				this.editSelect.page.pages >= this.editSelect.page.pageIndex
			) {
				this.editSelect.loadingSelect = true;
				this.loading = true;
				let obj = this.$cloud.objMerge(this.yxsearch, this.editUnSelect.page);
				this.$api
					.request(this.$url.UserMachine.userEquipment, this.$method.get, obj)
					.then(res => {
						if (res.code === 0 && res.data.records.length > 0) {
							this.selectList = this.selectList.concat(res.data.records);
							this.editSelect.page.pages = parseInt(res.data.pages);
							this.editSelect.page.pageIndex =
								this.editSelect.page.pageIndex + 1;
						}
						this.editSelect.loadingSelect = false;
						this.loading = false;
					})
					.catch(() => {
						this.editSelect.loadingSelect = false;
						this.loading = false;
					});
			}
		},
		// 修改设备到分组
		addMachine(type) {
			if (
				(type === 0 && this.unselectChangeList.length > 0) ||
				(type === 1 && this.selectChangeList.length > 0)
			) {
				if (type === 0) {
					this.userMachineGroup.userMachineId = this.$cloud.getIds(
						this.unselectChangeList
					);
				} else {
					this.userMachineGroup.userMachineId = this.$cloud.getIds(
						this.selectChangeList
					);
				}
				this.userMachineGroup.type = type;
				this.$api
					.request(
						this.$url.UserMachine.updateGroupId,
						this.$method.put,
						this.userMachineGroup
					)
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.editSelect.page.pageIndex = 1;
							this.editUnSelect.page.pageIndex = 1;
							this.selectList = [];
							this.unselectList = [];
							this.loadEditUnSelect();
							this.loadEditSelect();
						}
					})
					.catch(err => {
						this.$notify({
							title: this.$t("common.tip"),
							message: err.msg,
							type: "error",
						});
					});
			}
		},
		// 移除设备分组
		delMachine() {
			if (this.selectChangeList.length > 0) {
				this.userMachineGroup.userMachineId = this.$cloud.getIds(
					this.selectChangeList
				);
				this.userMachineGroup.type = 1;
				this.$api
					.request(
						this.$url.UserMachine.updateGroupId,
						this.$method.put,
						this.userMachineGroup
					)
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
						}
					})
					.catch(err => {
						this.$notify({
							title: this.$t("common.tip"),
							message: err.msg,
							type: "error",
						});
					});
			}
		},
	},
};
</script>
<style>
.right {
	float: right;
}
.el-form--label-top .el-form-item__label {
	padding: 0 !important;
}
</style>
